// credito personal
export const NEXT_STEP     = "NEXT_STEP";
export const SET_NOMINA_ID = "SET_NOMINA_ID"